import {
  NOTIFICATION_RESET,
  NOTIFICATION_SUCCESS,
  NOTIFICATION_ERROR,
  NOTIFICATION_LOADING
} from '../../actions/notification/constants'

const initialState = {
  alerts: [],
  loading: false,
  loadingBar: 0
}

export default function reducer (state = initialState, action) {
  const {payload} = action

  switch (action.type) {
    case NOTIFICATION_SUCCESS:
      return {
        ...state,
        alerts: [...state.alerts, {
          type: 'success',
          message: payload.message
        }]
      }
    case NOTIFICATION_ERROR:
      return {
        ...state,
        alerts: [...state.alerts, {
          type: 'error',
          message: payload.message
        }]
      }
    case NOTIFICATION_RESET:
      return {
        ...state,
        alerts: []
      }
    case NOTIFICATION_LOADING:
      let loadingBar
      if (payload.loading) {
        loadingBar = (state.loadingBar + 30)
      } else {
        loadingBar = (state.loadingBar > 0 ? state.loadingBar - 30 : 0)
      }
      return {
        ...state,
        loading: payload.loading,
        loadingBar: loadingBar
      }
    default:
      return {...state}
  }
}



// WEBPACK FOOTER //
// app/javascript/components/reducers/notification/notification.js